"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});

/* ----- qa ----- */
$(".qa__question").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

$(".megaMenu__btn").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});


document.addEventListener('DOMContentLoaded', function() {
    const menuBtn = document.querySelector('.menu__btn');
    const menu = document.querySelector('.menu');
    menuBtn.addEventListener('click', function() {
        menuBtn.classList.toggle('is-active');
        menu.classList.toggle('is-active');
    });
});




  /* ----- スライダー ----- */
  $('.fv-slider').slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    speed: 1000,
    pauseOnHover: false,
    dots: false,
    arrows: false,
    centerMode: true,
    asNavFor: '.navi-slider'
  });

  $('.fv-sub-slider').slick({
    slidesToShow: 3,
    asNavFor: '.fv-slider',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '0px',
  });

  $('.fv-circle').slick({
    slidesToShow: 3,
    asNavFor: '.fv-slider',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '0px',
    vertical: true,
  });

  $('.fv-sub-slider').find('.slick-slide').click(function() {
    let slickIndex = $(this).data('slick-index');
    $('.fv-circle').find('.slick-slide').removeClass('slick-current');
    $('.fv-circle').find('.slick-slide[data-slick-index="' + slickIndex + '"]').addClass('slick-current');
  })




document.addEventListener("DOMContentLoaded", function () {
  // voiceスライダー
  const voiceSlider = document.querySelector('.voice__slider');
  if (voiceSlider) {
    const splide = new Splide(".voice__slider", {
      // autoplay: true, // 自動再生
      type: "loop", // ループ
      pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
      interval: 2000, // 自動再生の間隔
      speed: 1000, // スライダーの移動時間
      padding: "15%", // スライダーの左右の余白
      gap: 30, // スライド間の余白
      pagination: false,
      breakpoints: {
        768: {
          padding: "10%", // スライダーの左右の余白
          gap: 20, // スライド間の余白
        },
      },
    }).mount();
  } else {
    console.log('voice__slider element not found');
  }
});



/* ----- スムースクロール ----- */
// 固定ヘッダー（固定しない場合は = 0）
const headerHeight = document.querySelector('header').offsetHeight;

// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      window.scrollTo({
        top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
        behavior: 'smooth',
      });

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};

// 別ページ遷移後にスムーススクロール
const urlHash = window.location.hash;
if (urlHash) {
  const target = document.getElementById(urlHash.slice(1));
  if (target) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, '', window.location.pathname);
    window.scrollTo(0, 0);

    window.addEventListener("load", () => {
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo(0, position);

      // ハッシュを再設定
      history.replaceState(null, '', window.location.pathname + urlHash);
    });
  }
}



/* ----- top-btnの表示 ----- */
window.onload = function() {
    // スクロールイベントを監視し、2000px以上スクロールされたらボタンを表示する
  window.addEventListener("scroll", function() {
    var scrollButton = document.querySelector(".top-btn");
    if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
        scrollButton.style.opacity = 1;
    } else {
        scrollButton.style.opacity = 0;
        setTimeout(function () {
        }, 500); // アニメーションが終わるまでの時間
    }
  });
};

// ページトップにスクロールする関数
function scrollToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
